/**
 * Delta feed: commentary payload shape `{ commentaries: { inns1: [{ ball, commentary, ... }], ... } }`.
 * Used to open Squares during TOSS PENDING only after a real toss text appears (rejects "0 won the toss").
 */

import { commentaryIndicatesRealTossWon } from "./squaresPlayOpenWindow";

/**
 * @param {unknown} commentary - `commentary` from socket / merged stream (may be null)
 * @returns {boolean} true if any commentary line indicates a team won the toss
 */
export function commentaryIndicatesTossWon(commentary) {
  return commentaryIndicatesRealTossWon(commentary);
}
